/**
 *
 * Question
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';

import { swalSuccess, swalWarning } from '@/utils/swal2';

export default {
  name: 'FollowBtn',

  props: {
    extraClasses: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      isOverFollowedBtn: false,
    };
  },

  computed: {
    ...mapState('QA/Question', {
      ms_qaQuestion: 'qaQuestion',
      ms_res_follow: 'res_follow',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),
  },

  methods: {
    ...mapActions('QA/Question', {
      ma_toFollow: 'toFollow',
      ma_toUnFollow: 'toUnFollow',
    }),

    toggleIsOverFollowedBtn() {
      if (this.ms_qaQuestion.isFollowed) {
        this.isOverFollowedBtn = !this.isOverFollowedBtn;
      }
    },

    async toFollow() {
      if (!this.mg_userInfo.isCurrentStudent) {
        swalWarning('你是未付费用户不能关注');
      } else {
        await this.ma_toFollow({
          questionId: this.$route.params.id,
        });
        if (200 === this.ms_res_follow.status) {
          swalSuccess('关注成功！');
        }
      }
    },

    async toUnFollow() {
      await this.ma_toUnFollow({
        questionId: this.$route.params.id,
      });
      if (200 === this.ms_res_follow.status) {
        swalSuccess('取消关注成功！');
      }
    },

    handleClick() {
      if (!this.ms_qaQuestion.isFollowed) {
        this.toFollow();
      } else {
        this.toUnFollow();
      }
    },
  },
};
